import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
/* Constants */
import { TrackingConstant } from 'client/tracking/constant';
import { DEALERSHIP_TRANSFER_TYPE } from 'site-modules/shared/components/delivery/constants';
/* Utils */
import { TrackingHandler } from 'client/tracking/handler';
import { formatPriceString } from 'site-modules/shared/utils/price-utils';
/* Components */
import { VehicleParam } from 'site-modules/shared/components/car-buying/vehicle-param/vehicle-param';
import { TooltipTextItem } from 'site-modules/shared/components/tooltip-text-item/tooltip-text-item';
import { isCarMax } from 'site-modules/shared/utils/dealer-details-utils';

import './delivery-details-tooltip.scss';

export function DeliveryDetailsTooltip({
  deliveryFee = 0,
  price = 0,
  labelClassName = '',
  classNameWrapper = '',
  dealer = '',
  deliveryType = '',
  deliveryDestinationName = '',
}) {
  const onDeliveryFeesTooltipOpen = () => {
    TrackingHandler.fireEvent(TrackingConstant.ACTION_VIEW_CONTENT, {
      event_data: {
        action_cause: TrackingConstant.ACTION_CAUSE_LINK_CLICK,
        value: 'delivery-details',
        creative_id: 'used-vdp-delivery-tooltip',
      },
    });
  };

  const formattedSummaryPrice = formatPriceString(price + deliveryFee);
  const isCarMaxDealer = isCarMax(dealer);

  const priceBreakdown = (
    <div className={classNames('price-breakdown-wrapper', classNameWrapper)}>
      <div className="fw-bold size-16 mb-1">Price Breakdown</div>
      <VehicleParam label="List Price" value={formatPriceString(price)} className="mb-1 medium" valueClassName="ms-1" />
      <VehicleParam
        label="Delivery Fee*"
        value={formatPriceString(deliveryFee)}
        className="medium"
        valueClassName="ms-1"
      />
      <hr className="my-0_75" />
      <VehicleParam label="Total" value={formattedSummaryPrice} className="fw-bold medium" valueClassName="ms-1" />
      <div className="medium mt-1">
        {`${
          isCarMaxDealer && deliveryType === DEALERSHIP_TRANSFER_TYPE ? `Ships to ${deliveryDestinationName}. ` : ''
        }Please note that Edmunds price ratings do not take delivery fees into account.`}
      </div>
    </div>
  );

  return (
    <TooltipTextItem
      buttonClassName="delivery-details-btn small p-0 border-0"
      id="delivery-tooltip"
      item={{
        text: priceBreakdown,
        placement: 'top',
      }}
      tooltipClassName="px-1 tooltip-vehicle-price"
      onTooltipOpen={onDeliveryFeesTooltipOpen}
    >
      <span className={classNames('text-underline text-primary-darker', labelClassName)}>Details</span>
    </TooltipTextItem>
  );
}

DeliveryDetailsTooltip.propTypes = {
  deliveryFee: PropTypes.number,
  price: PropTypes.number,
  classNameWrapper: PropTypes.string,
  dealer: PropTypes.string,
  deliveryType: PropTypes.string,
  deliveryDestinationName: PropTypes.string,
  labelClassName: PropTypes.string,
};
